/** Mise en sourdine de la confirmation « Métier différent ».
 *
 *  Répartir une journée entière sur un compagnon dont la zone de dispo porte un
 *  autre métier rouvrait la modale à chaque magnet déposé. La sourdine force le
 *  placement sans plus rien demander jusqu'à l'échéance choisie. Elle vit dans le
 *  navigateur, comme les autres préférences d'affichage de l'atelier : c'est un
 *  confort de saisie, pas un réglage d'organisation.
 */

const STORAGE_KEY = "heric_atelier_metier_mismatch_snooze";

/** Émis à chaque pose/levée de sourdine : l'indicateur de l'atelier suit sans
 *  qu'on ait à faire remonter l'état jusqu'à lui. */
export const METIER_SNOOZE_EVENT = "heric:metier-mismatch-snooze";

function notifyChange() {
  try {
    window.dispatchEvent(new Event(METIER_SNOOZE_EVENT));
  } catch {}
}

export const SNOOZE_OPTIONS = {
  "24h": { ms: 24 * 60 * 60 * 1000, label: "24 h" },
  "7j": { ms: 7 * 24 * 60 * 60 * 1000, label: "7 jours" },
} as const;

export type SnoozeDuration = keyof typeof SNOOZE_OPTIONS;

/** Échéance de la sourdine, ou null si elle est absente / dépassée. */
export function getMetierMismatchSnoozeUntil(): number | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const until = parseInt(raw, 10);
    if (!until || until <= Date.now()) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return until;
  } catch {
    return null;
  }
}

export function isMetierMismatchSnoozed(): boolean {
  return getMetierMismatchSnoozeUntil() !== null;
}

export function snoozeMetierMismatch(duration: SnoozeDuration) {
  try {
    localStorage.setItem(STORAGE_KEY, String(Date.now() + SNOOZE_OPTIONS[duration].ms));
  } catch {}
  notifyChange();
}

export function clearMetierMismatchSnooze() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
  notifyChange();
}
